import { Controller } from "@hotwired/stimulus"

// Scales each 1920×1080 deck slide (operator/decks/index and show) to the width of its frame,
// through the --dk-scale variable the slide's transform reads.
export default class extends Controller {
  static targets = ["frame"]

  connect() {
    this.observer = new ResizeObserver(() => this.scale())
    this.frameTargets.forEach((frame) => this.observer.observe(frame))
    this.scale()
  }

  disconnect() {
    this.observer?.disconnect()
  }

  scale() {
    this.frameTargets.forEach((frame) => {
      frame.style.setProperty("--dk-scale", frame.clientWidth / 1920)
    })
  }
}
